import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function QuickLinks() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                漫画分类导览
              </h2>
              <Link
                to="/category/rexue-maoxian"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/40 transition-all duration-200 text-center cursor-pointer"
                >
                  <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200 mb-2">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <div className="text-sm font-medium text-foreground-800">{cat.name}</div>
                  <div className="text-xs text-foreground-500 mt-1">{cat.count.toLocaleString()}部</div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                最新教程文章
              </h2>
              <Link
                to="/article/jmcomic-2026-latest-official-address"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
              </Link>
            </div>
            <div className="space-y-3">
              {articles.slice(0, 3).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/40 transition-all duration-200 cursor-pointer group"
                >
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-20 h-14 rounded-lg object-cover flex-shrink-0"
                    loading="lazy"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>{article.readTime}阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}